export const allList = [
  "dashboard",
  "report",
  "timesheet",
  "leaves",
  "service-request",
  "help-desk",
  "travel-desk",
  "performance-management",
  "document-templates",
  "employee-hierarchy",
  "teams",
  "recruitment",
  "payroll",
  "tax",
  "stage-templates",
  "email-templates",
  "company-resources",
  "hr-letter",
  "leave-history",
  "expense-history",
  "expense-request",
  "expense-settings",
  "leave-request",
  "leave-category",
  "leave-settings",
  "individual-leave-settings",
  "public-holidays",
  "payroll-sheet",
  "salary-breakdown",
  "salary-components",
  "salary-structure",
  "payroll-air-ticket",
  "user-role",
  "bulk-import",
  "all-imports",
  "organization-basic-settings",
  "organization-settings",
  "manage-branches",
  "custom-fields",
  "office-settings",
  "employees",
  "qr-code-settings",
  // "qr-code",
  "work-status",
  "job-posts",
  "talent-pool",
  "recruitment-companies",
  "activity",
  "project",
  "training",
  "shift",
  "leave-calendar",
  "announcement",
  "onboarding-templates",
  "job-ad-posts",
  "onboarding-tasks",
  "email-signature",
];
